import React from "react";
import { ValidationConstraints } from "@/components/tasks/types";

interface ValidationRulesSummaryProps {
  validation: ValidationConstraints;
}

export default function ValidationRulesSummary({
  validation,
}: ValidationRulesSummaryProps) {
  if (Object.keys(validation).length === 0) {
    return null;
  }

  return (
    <div className="bg-blue-100 p-3 rounded border border-blue-300">
      <h6 className="text-xs font-medium text-blue-800 mb-2">
        Active Validation Rules:
      </h6>
      <ul className="text-xs text-blue-700 space-y-1">
        {validation.required && <li>• Field is required</li>}
        {validation.minLength && (
          <li>• Minimum {validation.minLength} characters</li>
        )}
        {validation.maxLength && (
          <li>• Maximum {validation.maxLength} characters</li>
        )}
        {validation.pattern && (
          <li>• Must match pattern: {validation.pattern}</li>
        )}
        {validation.min !== undefined && (
          <li>• Minimum value: {validation.min}</li>
        )}
        {validation.max !== undefined && (
          <li>• Maximum value: {validation.max}</li>
        )}
        {validation.customMessage && (
          <li>• Custom message: "{validation.customMessage}"</li>
        )}
      </ul>
    </div>
  );
}
